export default {
  cardText: {
    type: 'string',
    default: '',
  },
  cardButtonHref: {
    type: 'string',
    default: '',
  },
  isModal: {
    type: 'boolean',
    default: false,
  },
  icon: {
    type: 'object',
    default: {
      id: '',
      src: '',
      alt: '',
    },
  },
  variant: {
    type: 'string',
    default: 'defaultSelf',
  },
};
